/* ==========================================================================
   BRACELY — Knee Sleeves PDP behaviour
   --------------------------------------------------------------------------
   When a customer picks a different colour, the main image swaps to that
   colourway — but if they have scrolled past the image to reach the swatches,
   the change happens off-screen. This scrolls the image back into view.

   Deliberately markup-agnostic: it listens for any change event, then checks
   whether the control that changed belongs to a Colour option by reading the
   surrounding fieldset. If it cannot tell, it does nothing.
   ========================================================================== */

(function () {
  'use strict';

  var TEMPLATE = 'product.knee-sleeves';

  function onThisTemplate() {
    var main = document.getElementById('MainContent');
    return !!main && main.getAttribute('data-template') === TEMPLATE;
  }

  function looksLikeColour(node) {
    if (!node) return false;

    var text = '';

    if (node.getAttribute) {
      text = node.getAttribute('data-option-name') || '';
    }

    if (!text && node.querySelector) {
      var legend = node.querySelector('legend');
      if (legend) text = legend.textContent || '';
    }

    if (!text && node.textContent) {
      text = node.textContent.slice(0, 80);
    }

    return /colou?r/i.test(text);
  }

  function scrollToMedia() {
    var media = document.querySelector('.product-information__media');
    if (!media) return;

    var rect = media.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    // Already fully visible — leave the page where it is.
    if (rect.top >= 0 && rect.bottom <= viewportHeight) return;

    var offset = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'), 10);
    if (isNaN(offset)) offset = 0;

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    var top = rect.top + scrollTop - offset - 12;
    if (top < 0) top = 0;

    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    try {
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    } catch (e) {
      window.scrollTo(0, top);
    }
  }

  function handleChange(event) {
    try {
      if (!onThisTemplate()) return;

      var target = event.target;
      if (!target || !target.closest) return;

      var field = target.closest('fieldset, [data-option-name], .variant-option');
      if (!looksLikeColour(field)) return;

      // Let the gallery finish swapping to the new colourway first.
      window.setTimeout(scrollToMedia, 140);
    } catch (e) {
      /* never break the page over a scroll nicety */
    }
  }

  document.addEventListener('change', handleChange, true);
})();
